import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { Route, Redirect } from 'react-router-dom';
import { Translate } from 'core/translate';
import PackageDetailsItem from './PackageDetailsItem';
import PackagePricing from '../../components/packages/PackagePricing';

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton
} from '../../common/modal/Modal';

const getButtons = ({ option, onClose, onSelect }) => {
  const { removable, selected } = option;
  const analyticsKey = option.description;

  if (selected && !removable) {
    return (
      <ModalFooterPrimaryButton onClick={onClose} data-dtm={analyticsKey} />
    );
  }

  return (
    <Fragment>
      <ModalFooterCancelButton onClick={onClose} data-dtm={analyticsKey} />
      <ModalFooterPrimaryButton
        data-dtm={analyticsKey}
        onClick={() => {
          onSelect(option);
        }}>
        <Translate value={selected ? 'remove.option' : 'select'} />
      </ModalFooterPrimaryButton>
    </Fragment>
  );
};

const PackageItems = ({ isLite, option }) => {
  if (isLite) {
    const packageItems = option.packageOptions.map(packageOption => {
      return <li key={packageOption.id}>{packageOption.description}</li>;
    });

    return (
      <div className="package-details__description">
        <ul>{packageItems}</ul>
      </div>
    );
  }

  return (
    <div
      className="package-details__description"
      dangerouslySetInnerHTML={{ __html: option.longCFD }}
    />
  );
};

const getPackageOptionsWithImage = option => {
  return [option]
    .concat(_.sortBy(option.packageOptions, 'id'))
    .filter(packageOption => {
      return !!packageOption.largeImageUrl;
    });
};

const PackageDisclaimer = ({ disclaimer }) => {
  if (!disclaimer) {
    return null;
  }

  return (
    <div
      className="package-details__disclaimer"
      dangerouslySetInnerHTML={{ __html: disclaimer }}
    />
  );
};

export class PackageDetails extends Component {
  render() {
    const { packageId, onClose, option, isLite, onSelect } = this.props;

    if (!option) {
      return null;
    }

    const optionDescription = option.description;
    const packageOptions = getPackageOptionsWithImage(option);
    const image = _.some(option.packageOptions, packageOption => {
      return packageOption.videoUrl || packageOption.largeImageUrl;
    });

    const defaultItemId = _.get(_.first(packageOptions), 'id');
    const packageUrl = `/packages/package/${packageId}`;
    const defaultItemUrl = `${packageUrl}/item/${defaultItemId}`;

    return (
      <Modal
        isOpen={true}
        onRequestClose={onClose}
        contentLabel={optionDescription}>
        <ModalHeader
          text={optionDescription}
          analyticsKey={optionDescription}
          onClose={onClose}
        />
        <ModalBody>
          <div className="modal-body__content">
            <Route
              exact
              path={packageUrl}
              render={() => {
                if (packageOptions.length === 0) {
                  return null;
                }
                return <Redirect to={defaultItemUrl} />;
              }}
            />
            <Route
              path={`${packageUrl}/item/:itemId`}
              render={({ match }) => {
                const id = match.params.itemId;

                if (packageOptions.length === 0) {
                  return <Redirect to={packageUrl} />;
                }

                if (!_.find(packageOptions, { id })) {
                  return <Redirect to={defaultItemUrl} />;
                }

                return (
                  <PackageDetailsItem
                    onClose={onClose}
                    packageId={packageId}
                    itemId={id}
                    optionDescription={optionDescription}
                    packageOptions={packageOptions}
                    image={image}
                  />
                );
              }}
            />
            <div className="modal-body__description-container">
              <div className="package-details__pricing">
                <PackagePricing option={option} />
              </div>
              <PackageItems isLite={isLite} option={option} />
              <PackageDisclaimer disclaimer={option.disclaimer} />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ModalFooterButtons>
            {getButtons({
              option,
              onClose,
              onSelect
            })}
          </ModalFooterButtons>
        </ModalFooter>
      </Modal>
    );
  }
}
export default PackageDetails;
